// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/*导入element组件*/
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import enLang from 'element-ui/lib/locale/lang/zh-CN'
/*导入路由*/
import router from './router'
//权限路由
//import permission from './permission.js'
/*导入全局状态*/
import store from './store'

/*导入打印组件*/
//import printJS from 'print-js'
import './assets/style/leagure.css';
import './assets/style/element-variables.scss'
import './assets/style/element-ui.scss'
import business from './utils/transform/business';

/*注入element-ui组件*/
Vue.use(Element, {
  size: 'medium',
  local: enLang
})

//Vue.use(printJS)
Vue.config.productionTip = false
Vue.prototype.$baseUrl= store.getters.baseUrl;
Vue.prototype.$business = business;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js